import React from 'react'
import { Box } from 'reflexbox/styled-components'

const Card = props => <Box {...props} />

Card.defaultProps = {
  p: '24px',
  sx: {
    boxShadow: 'under.2',
    borderRadius: 'default',
  },
}

Card.propTypes = {
  ...Box.propTypes,
}

export default Card
